import { observable, action, reaction, computed } from 'mobx';

import analyticsStore from './analytics';
import intlStore from './intl';

import moment from 'moment';

import SOUNDTRACK from '../data/soundtrack';

class Soundtrack {
  constructor() {
    reaction(
      () => this._audio,
      () => {
        this.setPosition(0);
        this.setPlaying(false);
      }
    );
  }

  @observable
  _playing = false;

  @observable
  _audio = 0;

  @observable
  _position = 0;

  @observable
  _duration = 0;

  @action
  setPosition(position) {
    this._position = position;
  }

  @action
  setDuration(duration) {
    this._duration = duration;
  }

  @action
  setPlaying(playing) {
    if (playing) {
      let { name } = this.status;
      name = intlStore.dictionary[name];

      analyticsStore.event({
        category: 'Music',
        action: 'Play',
        label: name,
      });
    }
    this._playing = playing;
  }

  @action
  setAudio(audio) {
    this._audio = audio;
  }

  @action
  play() {
    this.setPlaying(true);
  }

  @action
  pause() {
    this.setPlaying(false);
  }

  @action
  stop() {
    this.setPlaying(false);
    this.setPosition(0);
  }

  @computed
  get status() {
    const audio = this._audio;
    const position = this._position;
    const playing = this._playing;
    const duration = this._duration;
    const durationFormatted = moment(0)
      .set({ milliseconds: duration })
      .format('mm:ss');
    const positionFormatted = moment(0)
      .set({ milliseconds: position })
      .format('mm:ss');
    const sound = this.audios.find((sound) => sound.id === audio);
    let ellapsed = (position / this._duration) * 100;

    if (isNaN(ellapsed)) ellapsed = 0;

    return Object.assign({}, sound, {
      position,
      playing,
      positionFormatted,
      duration,
      durationFormatted,
      ellapsed,
    });
  }

  @computed
  get audios() {
    return SOUNDTRACK;
  }
}

export default new Soundtrack();
